<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <basics
            v-if='wo'
            :wo='wo'
            @update='update'
          ></basics>
        </v-col>
        <v-col cols='12' md='4'>
          <problem-description
            v-if='wo'
            :wo='wo'
            @update='update'
          ></problem-description>
          <field-instructions
            class='mt-6'
            v-if='wo && wo.project'
            :wo='wo'
          ></field-instructions>
        </v-col>
         <v-col cols='12' md='4'>
          <scheduling-considerations
            v-if='wo'
            :wo='wo'
            @update='update'
          ></scheduling-considerations>
        </v-col>
        <v-col cols='12' md='4'>
          <outstanding-service
            v-if='wo.project'
            :project='wo.project_obj'
            :disableAdd='wo.office_complete'
            allowEdits
            showHelp
          ></outstanding-service>
        </v-col>
        <v-col cols='12' md='4'>
          <stickies
            v-if='wo && (wo.project_obj || wo.estimate_obj)'
            :project='wo.project_obj'
            :estimate='wo.estimate_obj'
          ></stickies>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols='12' md='4'>
          <scheduling-log
            v-if='wo'
            :wo='wo'
            @update='update'
          ></scheduling-log>
        </v-col>
        <v-col cols='12' md='4'>
          <crew-visits
            v-if='wo'
            :wo='wo'
          ></crew-visits>
        </v-col>
          <v-col cols='12' md='4'>
          <invoicing
            v-if='wo'
            :wo='wo'
            @update='update'
          ></invoicing>
        </v-col>
      </v-row>
      <wc-page-section class='mt-n7' title='Files'></wc-page-section>
        <v-row style="padding-bottom: 150px;">
          <v-col cols='12' md='12'>
            <wo-files
              v-if="wo"
              :files='wo.work_order_file_data'
              :work_order_id='wo.id'
            ></wo-files>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
import Basics from './Basics';
import ProblemDescription from './ProblemDescription';
import Stickies from '@/modules/projects/components/Stickies';
import WorkOrderFiles from '@/components/files/WorkOrderFiles';
import FieldInstructions from './FieldInstructions';
import SchedulingConsiderations from './SchedulingConsiderations';
import OutstandingService from '@/modules/projects/components/OutstandingService';
import SchedulingLog from './SchedulingLog';
import CrewVisits from './CrewVisits';
import Invoicing from './Invoicing';
export default {
  name: 'wo-overview',
  props: {
    wo: {
      required: true
    }
  },
  methods: {
    update (wo) {
      this.$emit('update', wo)
    },
    refresh (wo) {
      this.$emit('refresh', wo)
    }
  },
  components: {
    'basics': Basics,
    'wo-files': WorkOrderFiles,
    'stickies': Stickies,
    'field-instructions': FieldInstructions,
    'invoicing': Invoicing,
    'scheduling-considerations': SchedulingConsiderations,
    'crew-visits': CrewVisits,
    'scheduling-log': SchedulingLog,
    'problem-description': ProblemDescription,
    'outstanding-service': OutstandingService
  }
}
</script>
